_BannerFlowApp.directive("video", function ($sce) {
    return {
        priority: 0,
        restrict: "E",
        replace: true,
        scope: {
            url: "@"
        },
        controller: function ($scope) {
            $scope.isPlaying = false;
            $scope.safeUrl = $sce.trustAsResourceUrl(
                $scope.url + "?background=1&autoplay=1&portrait=0"
            );

            $scope.play = function () {
                $scope.isPlaying = true;
                $scope.safeUrl = $sce.trustAsResourceUrl($scope.url + "?autoplay=1&byline=0&title=0");
            };
        },
        templateUrl: "/legacy-app/js/directives/video/video.html"
    };
});
